export default "__VITE_ASSET__DfHvpxCg__"